import React from 'react';
import PropTypes from 'prop-types';
import iconSrc from '../../../utils/iconSrc';

// Components
import LinkHandler from '../../link-handler';
import { VisuallyHidden } from '../../styled/accessibility';

// Styles
import { StyledLink, DirectionIcon, StyledSVG } from './styles';

const PaginationLink = ({ title, linkDirection, path, label }) => (
  <StyledLink as={LinkHandler} link={{ path }} $linkDirection={linkDirection}>
    <DirectionIcon $linkDirection={linkDirection}>
      {title}
      <VisuallyHidden>:</VisuallyHidden>
      <StyledSVG
        $linkDirection={linkDirection}
        height="18"
        width="18"
        src={
          linkDirection === 'prev'
            ? iconSrc('chevron-left')
            : iconSrc('chevron-right')
        }
      />
    </DirectionIcon>
    <span>{label}</span>
  </StyledLink>
);

PaginationLink.propTypes = {
  path: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  linkDirection: PropTypes.oneOf(['prev', 'next']).isRequired,
  title: PropTypes.string.isRequired,
};

export default PaginationLink;
